import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_SECONDS_FORMAT } from 'src/app/core/ccomx-date-formats';
import {
  isTaskLogDateField,
  isTaskLogDateValue,
  taskLogFieldTranslationKey,
} from 'src/app/task-user/functions/task-log-change.helpers';
import { UserDrillsRoutes } from '../../../../../core/enums/routes.enum';
import { DrillsActionType } from '../../../../../drills-user/components/enum/drills-action-type';

const VALUE_ONLY_CHANGE_FIELDS = new Set(['comment', 'performComment', 'evaluation']);

@Component({
  selector: 'app-drills-log-template',
  templateUrl: './drills-log-template.component.html',
  styleUrls: ['./drills-log-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DrillsLogTemplateComponent {
  @Input() columnName: string;
  @Input() element: any;

  drillActionTypes = DrillsActionType;
  performViewRoute = UserDrillsRoutes.PerformView;
  dateFormat = DEFAULT_DATE_TIME_SECONDS_FORMAT;
  getFieldLabelKey = taskLogFieldTranslationKey;

  isDateChange(fieldName: string, value: string | null | undefined): boolean {
    return isTaskLogDateField(fieldName) || isTaskLogDateValue(value);
  }

  shouldShowValueOnly(fieldName: string): boolean {
    return VALUE_ONLY_CHANGE_FIELDS.has(taskLogFieldTranslationKey(fieldName));
  }
}
